import React, { useState, useRef } from 'react';
import { Star, StarHalf, Play, Pause, Send } from 'lucide-react';
const TESTIMONIALS = [{
  id: 1,
  name: 'Luis R.',
  location: '📍 Tepic, 21 años',
  quote: 'La timidez me paralizaba en el colegio, haciéndome pasar una mala pasada hasta que probé Neuro-Control Mental. Escucha mi historia aquí abajo.',
  img: 'https://images.unsplash.com/photo-1539571696357-5a69c17a67c6?auto=format&fit=crop&w=150&q=80',
  stars: 5,
  audioUrl: 'https://cdn.magicpatterns.com/uploads/iD4sgPSPwayvogm5TXp2bB/202603131036.mp4',
  highlight: true
}, {
  id: 2,
  name: 'Mariana G.',
  location: '📍 Monterrey, 26 años',
  quote: 'Dejé de cancelar planes. El ejercicio de reset del nervio vago me quita ese nudo en el estómago en minutos.',
  img: 'https://i.pravatar.cc/150?img=5',
  stars: 4.5
}, {
  id: 3,
  name: 'Arturo J.',
  location: '📍 Guadalajara, 27 años',
  quote: 'Pensé que era algo esotérico pero tiene toda la lógica médica. Mi sobrepensamiento nocturno bajó desde la primera semana.',
  img: 'https://i.pravatar.cc/150?img=12',
  stars: 4
}];
function StarRating({
  rating
}: {
  rating: number;
}) {
  const fullStars = Math.floor(rating);
  const hasHalf = rating % 1 !== 0;
  const emptyStars = 5 - fullStars - (hasHalf ? 1 : 0);
  return <div className="flex" data-id="element-227">
      {[...Array(fullStars)].map((_, i) => <Star key={`full-${i}`} className="w-4 h-4 fill-yellow text-yellow" data-id="element-228" />)}
      {hasHalf && <StarHalf className="w-4 h-4 fill-yellow text-yellow" data-id="element-229" />}
      {[...Array(emptyStars)].map((_, i) => <Star key={`empty-${i}`} className="w-4 h-4 text-charcoal/20" data-id="element-230" />)}
    </div>;
}
function AudioPlayer({
  url
}: {
  url: string;
}) {
  const [isPlaying, setIsPlaying] = useState(false);
  const [progress, setProgress] = useState(0);
  const audioRef = useRef<HTMLAudioElement>(null);
  const togglePlay = () => {
    if (audioRef.current) {
      if (isPlaying) {
        audioRef.current.pause();
      } else {
        audioRef.current.play();
      }
      setIsPlaying(!isPlaying);
    }
  };
  const handleTimeUpdate = () => {
    if (audioRef.current) {
      const current = audioRef.current.currentTime;
      const duration = audioRef.current.duration;
      setProgress(current / duration * 100);
    }
  };
  const handleEnded = () => {
    setIsPlaying(false);
    setProgress(0);
  };
  return <div className="mt-4 bg-white/60 rounded-full p-2 flex items-center gap-3 border border-terracotta/20" data-id="element-231">
      <audio ref={audioRef} src={url} onTimeUpdate={handleTimeUpdate} onEnded={handleEnded} className="hidden" data-id="element-232" />
      <button onClick={togglePlay} className="w-10 h-10 bg-terracotta rounded-full flex items-center justify-center text-white hover:bg-terracotta-hover transition-colors flex-shrink-0" data-id="element-233">
        {isPlaying ? <Pause className="w-5 h-5" data-id="element-234" /> : <Play className="w-5 h-5 ml-1" data-id="element-235" />}
      </button>
      <div className="flex-1 h-2 bg-charcoal/10 rounded-full overflow-hidden mr-3" data-id="element-236">
        <div className="h-full bg-terracotta transition-all duration-100 ease-linear" style={{
        width: `${progress}%`
      }} data-id="element-237" />
      </div>
    </div>;
}
export function SocialProof() {
  const [comment, setComment] = useState('');
  const [isPosted, setIsPosted] = useState(false);
  const [userRating, setUserRating] = useState(5);
  const [hoverRating, setHoverRating] = useState(0);
  const handlePostComment = (e: React.FormEvent) => {
    e.preventDefault();
    if (comment.trim()) {
      setIsPosted(true);
      setComment('');
      setUserRating(5);
      setTimeout(() => setIsPosted(false), 3000);
    }
  };
  return <section className="py-8 bg-navy" data-id="element-238">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-239">
        <div className="text-center mb-10" data-id="element-240">
          <span className="text-yellow font-bold tracking-widest text-sm uppercase mb-4 block" data-id="element-241">
            ¿Que dicen los que probaron el protoclolo?
          </span>
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-offwhite mb-4" data-id="element-242">
            4,223 mexicanos ya rompieron su timidez
          </h2>
          <div className="flex items-center justify-center space-x-1" data-id="element-243">
            {[...Array(5)].map((_, i) => <Star key={i} className="w-6 h-6 fill-yellow text-yellow" data-id="element-244" />)}
            <span className="ml-3 text-offwhite font-bold text-lg" data-id="element-245">4.8/5</span>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12" data-id="element-246">
          {TESTIMONIALS.map(t => <div key={t.id} className={`rounded-2xl p-8 shadow-xl flex flex-col relative overflow-hidden ${t.highlight ? 'bg-[#FFFBEB] border-2 border-yellow/50 transform md:-translate-y-2' : 'bg-cream'}`} data-id="element-247">
              {t.highlight && <div className="absolute top-0 right-0 bg-yellow text-navy text-xs font-bold px-3 py-1 rounded-bl-lg" data-id="element-248">
                  TESTIMONIO DESTACADO
                </div>}
              <div className="flex items-center mb-5 mt-2" data-id="element-249">
                <img src={t.img} alt={t.name} className="w-14 h-14 rounded-full object-cover border-2 border-sage" data-id="element-250" />
                <div className="ml-4" data-id="element-251">
                  <h4 className="font-bold text-charcoal" data-id="element-252">{t.name}</h4>
                  <p className="text-sm text-charcoal/60" data-id="element-253">{t.location}</p>
                </div>
              </div>
              <div className="mb-4" data-id="element-254">
                <StarRating rating={t.stars} data-id="element-255" />
              </div>
              <p className="text-charcoal/80 italic leading-relaxed flex-1" data-id="element-256">
                "{t.quote}"
              </p>
              {t.audioUrl && <AudioPlayer url={t.audioUrl} data-id="element-257" />}
            </div>)}
        </div>

        {/* Comment Section */}
        <div className="max-w-2xl mx-auto bg-white/5 border border-white/10 rounded-2xl p-6 md:p-8" data-id="element-258">
          <h3 className="text-xl font-heading font-bold text-offwhite mb-6" data-id="element-259">
            Dejanos tu experiencia Neuro-Control Mental
          </h3>

          <form onSubmit={handlePostComment} data-id="element-260">
            <div className="mb-4" data-id="element-261">
              <p className="text-offwhite/80 text-sm mb-2" data-id="element-262">
                ¿Cómo calificarías tu experiencia?
              </p>
              <div className="flex gap-1" data-id="element-263">
                {[1, 2, 3, 4, 5].map(star => <button key={star} type="button" onClick={() => setUserRating(star)} onMouseEnter={() => setHoverRating(star)} onMouseLeave={() => setHoverRating(0)} className="focus:outline-none transition-transform hover:scale-110" data-id="element-264">
                    <Star className={`w-6 h-6 ${star <= (hoverRating || userRating) ? 'fill-yellow text-yellow' : 'text-white/20'}`} data-id="element-265" />
                  </button>)}
              </div>
            </div>

            <div className="relative" data-id="element-266">
              <textarea value={comment} onChange={e => setComment(e.target.value)} placeholder="Escribe tu comentario aquí..." className="w-full bg-white/10 border border-white/20 rounded-xl p-4 text-offwhite placeholder:text-offwhite/40 focus:outline-none focus:border-yellow transition-colors resize-none h-24" data-id="element-267" />
              <button type="submit" disabled={!comment.trim()} className="absolute bottom-3 right-3 bg-terracotta hover:bg-terracotta-hover disabled:opacity-50 disabled:hover:bg-terracotta text-white p-2 rounded-lg transition-colors" data-id="element-268">
                <Send className="w-4 h-4" data-id="element-269" />
              </button>
            </div>
          </form>

          {isPosted && <div className="mt-4 bg-sage/20 border border-sage/30 text-sage px-4 py-3 rounded-lg text-sm font-medium flex items-center" data-id="element-270">
              <Star className="w-4 h-4 mr-2" data-id="element-271" />
              ¡Gracias! Tu comentario ha sido enviado y está pendiente de
              revisión.
            </div>}
        </div>
      </div>
    </section>;
}